<template>
<span>
  <el-checkbox v-model="value" :true-label="trueLabel" :false-label="falseLabel" @change="onChange"/>
</span>
</template>

<script>
import TwoStatusCellEditorMixin from './mixins/two-status-cell-editor';

export default {
  name: 'WCheckboxEditor',
  mixins: [TwoStatusCellEditorMixin],
  props: {
    /**
     * 체크 됐을 때 값
     */
    trueLabel: {
      type: [String, Number],
    },
    /**
     * 체크 해제 됐을 때 값
     */
    falseLabel: {
      type: [String, Number],
    },
  },
  methods: {
    /**
     * change 이벤트 핸들러
     * @author Ju
     * @param  {[type]} newValue [description]
     */
    onChange(newValue) {
      this.$emit('cell-edit-end', this.data, this.property, newValue, this.trueLabel === undefined ? newValue : this.trueLabel === newValue);
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/table/cell-editor/CheckboxEditor.vue